"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross3"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Filter' : _ref$placeholder,
    value = _ref.value,
    onChange = _ref.onChange;
  var handleChange = function handleChange(e) {
    onChange(e.target.value);
  };
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(value && _style["default"].withValue)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-control",
    type: "text",
    name: "filter",
    value: value,
    onChange: handleChange,
    placeholder: placeholder,
    autoComplete: "off"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].icon,
    onClick: function onClick() {
      return onChange('');
    }
  }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
};